export default "__VITE_ASSET__Ip2nL4ux__"